//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import SelectFaceListModal from "./SelectFaceListModal";
import SelectFaceModal from "./SelectFaceModal";
export default {
  name: 'TerminalList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    SelectFaceListModal: SelectFaceListModal,
    SelectFaceModal: SelectFaceModal
  },
  data: function data() {
    return {
      pagePath: '/ai/face/queryTerminalPagination',
      pageTitle: 'AI终端',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'aiDeviceCode',
        colName: 'aiDeviceCode',
        align: 'center',
        title: 'Ai设备编号'
      }, {
        dataIndex: 'count',
        title: '人脸数量',
        align: 'center',
        customRender: function customRender(text) {
          if (text != -1) {
            return text;
          } else {
            return '未知';
          }
        }
      }, {
        dataIndex: 'status',
        colName: 'status',
        title: '在线状态',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 150,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      this.queryParam.category = this.category;
      console.log(ids[1], ids[0]);

      if (ids[0] == 1) {
        // 根据站点id
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    handlePush: function handlePush(aiDeviceCode) {
      this.$refs.SelectFaceListModal.show(aiDeviceCode);
    },
    handleDelete: function handleDelete(aiDeviceCode) {
      this.$refs.SelectFaceModal.show(aiDeviceCode);
    }
  }
};